module.exports = __webpack_public_path__ + "img/logo-discord.e6e1cd8.svg";